import script from "./ordersSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ordersSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ordersSuccess.vue?vue&type=style&index=0&id=00c39dea&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c39dea"]])

export default __exports__